import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const MarketingSurveyAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "marketing-survey" */ './marketing-survey'),
  componentName: 'MarketingSurvey',
});
